import { createFileRoute } from "@tanstack/react-router";
import { MenuListing, menuQuery, FOOD_CATEGORIES } from "@/components/MenuListing";
import cocktailsMenuBg from "@/assets/cocktails-menu-bg.jpg.asset.json";
import { useTrackEvent } from "@/lib/analytics";

export const Route = createFileRoute("/food-menu")({
  loader: ({ context }) => context.queryClient.ensureQueryData(menuQuery),
  head: () => {
    const ogImage = "https://plunkets.ie/og-food.jpg";
    return {
      meta: [
        { title: "Food Menu Dublin City Centre — Pub Kitchen | Plunkets Pub" },
        { name: "description", content: "Full pub kitchen menu at Plunkets, Middle Abbey Street, Dublin 1. Full Irish breakfast, burgers, steak sandwiches, fish & chips, sharing boards and kids meals." },
        { name: "keywords", content: "pub food Dublin city centre, food menu Dublin, Irish breakfast Dublin, burgers Dublin, fish and chips Dublin, kids menu Dublin" },
        { property: "og:title", content: "Food Menu — Plunkets Pub Dublin" },
        { property: "og:description", content: "Full Irish breakfast, burgers, steak sandwiches, fish & chips and more — served daily in Dublin city centre." },
        { property: "og:type", content: "website" },
        { property: "og:url", content: "https://plunkets.ie/food-menu" },
        { property: "og:image", content: ogImage },
        { property: "og:image:alt", content: "Plunkets burger from the food menu in Dublin city centre" },
        { property: "og:image:width", content: "1200" },
        { property: "og:image:height", content: "630" },
        { property: "og:locale", content: "en_IE" },
        { property: "og:site_name", content: "Plunkets Pub Dublin" },
        { name: "twitter:card", content: "summary_large_image" },
        { name: "twitter:title", content: "Food Menu — Plunkets Pub Dublin" },
        { name: "twitter:description", content: "Proper pub kitchen menu in Dublin city centre." },
        { name: "twitter:image", content: ogImage },
      ],
      links: [{ rel: "canonical", href: "https://plunkets.ie/food-menu" }],
    };
  },
  component: FoodMenuPage,
});

function FoodMenuPage() {
  useTrackEvent("menu_view", { menu_name: "food", menu_slug: "food-menu" });
  return (
    <MenuListing
      eyebrow="Eat"
      title={<>Food <span className="text-gold-gradient">Menu</span></>}
      description="A proper pub kitchen — Full Irish breakfast, sharing boards, sandwiches, burgers, steaks, fish & chips, kids meals and desserts. Served daily in the heart of Dublin."
      backgroundUrl={cocktailsMenuBg.url}
      allowedCategories={FOOD_CATEGORIES}
    />
  );
}
